const FOOTER_HEIGHT = 900

export default function Footer() {
  return (
    <footer className="w-full">
      <iframe
        src="https://www.club4x4.com.au/embed/footer/"
        className="w-full border-0 block"
        height={FOOTER_HEIGHT}
        title="Footer"
      />
    </footer>
  )
}
